import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import $ from "jquery";
import cookie from "react-cookies";
import { toast } from "react-toastify";
import Axios from "axios";
import { format } from "date-fns";
import Swal from "sweetalert2";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import { GET_CART_DETAIL, GET_GLOBAL_SETTINGS } from "../../actions";
import { showPriceDirect, encodeValue, showLoader, hideLoader, getGstValue, addressFormat, getReverseGST, showOrderTime } from "../Settings/SettingHelper";
import { apiUrl, deliveryId, mainUrl, pickupId, uniqueID, CountryName, placeholderImage, companyName, currency, paymentImage } from "../Settings/Config";
import Header from "../Layout/Header";
import OrderAdvancedDatetimeSlot from "../Layout/OrderAdvancedDatetimeSlot";
import logo from "../../common/images/logo.png";
import closei from "../../common/images/img/close-top.svg";
const base64 = require("base-64");
const parse = require("html-react-parser");
let startTimePay;
class Checkout extends Component {
  constructor(props) {
    super(props);
    const seletedAvilablityId = cookie.load("availability") ?? "";
    const seletedAvilablityName = cookie.load("availabilityName") ?? "";

    const outletID = cookie.load("outletID") ?? "";
    const orderHandledOutlet = cookie.load("orderHandledOutlet") ?? "";
    const outletName = cookie.load("outletName") ?? "";
    const zoneID = localStorage.getItem("zoneID") ?? "";

    const orderDateTime = cookie.load("orderDateTime") ?? "";
    console.log(orderDateTime, "orderDateTimeorderDateTime");
    const displyDate = orderDateTime !== "" ? format(new Date(orderDateTime.replaceAll('"', "")), "do MMM yyyy") : "";
    const displyTime = orderDateTime !== "" ? format(new Date(orderDateTime.replaceAll('"', "")), "hh:mm a") : "";

    var isAdvanced = typeof cookie.load("isAdvanced") === "undefined" ? "" : cookie.load("isAdvanced");
    const customerID = localStorage.getItem("customerID") ?? "";

    const discountApplied = cookie.load("discountApplied") ?? "No";
    const promoFreeDelivery = cookie.load("promoFreeDelivery") ?? "No";
    const discount = cookie.load("discount") ?? 0;
    const promoCode = cookie.load("promoCode") ?? "";

    const deliveryTime = cookie.load("deliveryTime") ?? "";
    const slotType = cookie.load("slotType") ?? "";
    //const orderSlotEndTime = cookie.load("orderSlotEndTime") ?? "";
    //const orderSlotStrTime = cookie.load("orderSlotStrTime") ?? "";

    const redeemPoint = cookie.load("redeemPoint") ?? "";
    const redeemPointAmount = cookie.load("redeemPointAmount") ?? 0;

    const unitNumber = localStorage.getItem("deliveryUnitNumber") ?? "";
    const floorNumber = localStorage.getItem("deliveryFloorNumber") ?? "";

    const redeemAscentisPoint = cookie.load("redeemAscentisPoint") ?? 0;

    this.state = {
      loginPopup: false,
      seletedAvilablityId: seletedAvilablityId,
      seletedAvilablityName: seletedAvilablityName,
      customerID: customerID,
      outletID: outletID,
      zoneID: zoneID,
      zoneDetails: "",
      orderHandledOutlet: orderHandledOutlet,
      outletName: outletName,
      unitNumber: unitNumber,
      floorNumber: floorNumber,

      sameAsDeliveryAddress: true,
      billingUnitNumber: "",
      billingFloorNumber: "",
      billingAddress: "",
      billingPostalCode: "",

      sendAsGift: false,
      recipientName: "",
      recipientContactNo: "",
      recipientMessage: "",

      cartDetails: "",
      totalItem: 0,
      additionalChargeList: [],
      additionalChargeAmount: 0,
      cartstatus: "",
      subtotal: 0,
      promoCode: promoCode,
      discount: discount,
      redeemPoint: redeemPoint,
      redeemPointAmount: redeemPointAmount,
      freedeliveryCharge: 0,
      balancefreedeliveryCharge: 0,
      freeDeliveryPrecentage: 0,
      deliveryCharge: 0,
      taxAmount: 0,
      taxPercentage: 0,
      taxType: "",
      grandTotal: 0,
      globalSettings: [],
      companyEnableRapyd: false,
      companyEnableDeliveryFeeAuto: false,
      discountApplied: discountApplied,
      promoFreeDelivery: promoFreeDelivery,
      paymentMode: "",
      enableOmise: false,
      companyEnableOmisePayNow:false,
      omiseKey: "",
      holdername: "",
      cardNumber: "",
      expiration_month: "",
      expiration_year: "",
      security_code: "",
      cardImage: "",
      omisecodeerror: "",
      omiseyearerror: "",
      omisemontherror: "",
      omisecardrror: "",
      omisenameerror: "",

      enableStripe: false,

      /* For Advanced Slot */
      slotType: slotType,
      getDateTimeFlg: "",
      seleted_ord_date: orderDateTime,
      timeSlotType: 1,
      seleted_ord_time: "",
      seleted_ord_slot: "",
      seleted_ord_slotTxt: "",
      seleted_ord_slot_str: "",
      seleted_ord_slot_end: "",
      order_tat_time: cookie.load("orderTat") || 15,
      orderDateTime: orderDateTime,
      orderSlotVal: "",
      orderSlotTxt: "",
      orderSlotStrTime: "",
      orderSlotEndTime: "",
      labelDateName: seletedAvilablityName,
      labelTimeName: seletedAvilablityName,
      isAdvanced: isAdvanced,
      deliveryTime: deliveryTime,

      displyDate: displyDate,
      displyTime: displyTime,

      deliveryDatas: "",
      deliveryCharegLoadingStatus: false,

      deliveryIntitalLoad: false,

      updateTimes: "",
      additionalInformation: "",

      open: false,
      openomisePopup: false,
      openomisePayNowPopup: false,
      openomisePayNowRefID:'',
      omisePayNowQRCode: "",
      omisePayNowBalanceTime:'',
      enableAscentisCRM: false,
      appliedAscentisPoint: parseFloat(redeemAscentisPoint) > 0 ? true : false,
      availableAscentisPoint: 0,
      balanceAscentisPoint: 0,
      redeemAscentisPoint: redeemAscentisPoint,
      OTPPopup: false,
      otp1: "",
      otp2: "",
      otp3: "",
      otp4: "",
      otp5: "",
      otp6: "",

      allowToshowCheckout: false,
    };
  }
  componentDidMount() {
    $("body").css("overflow", "auto");

    if (this.state.customerID === "") {
      cookie.save("triggerLogin", "Yes", { path: "/" });
      cookie.save("redirect", "checkout", { path: "/" });
      this.props.history.push("/");
    } else if (this.state.seletedAvilablityId === "" || this.state.outletID === "") {
      cookie.save("triggerOrderType", "Yes", { path: "/" });
      cookie.save("redirect", "checkout", { path: "/" });
      this.props.history.push("/");
    } else if (this.state.outletID !== "") {
      if (this.state.seletedAvilablityId === deliveryId && this.state.zoneID === "") {
        cookie.save("triggerOrderType", "Yes", { path: "/" });
        cookie.save("redirect", "checkout", { path: "/" });
        this.props.history.push("/");
      } else {
        this.setState({ getDateTimeFlg: "yes" });
      }
    } else {
      this.setState({ getDateTimeFlg: "yes" });
    }
    const script = document.createElement("script");
    script.src = "https://cdn.omise.co/omise.js";
    script.async = true;
    document.body.appendChild(script);
    if (this.state.seletedAvilablityId === deliveryId) {
      this.loadZone();
    }
  }
  componentDidUpdate() {
    var sltdOrdDate = this.state.seleted_ord_date;
    var sltdOrdTime = this.state.seleted_ord_time;
    if (sltdOrdDate !== "" && sltdOrdTime !== "") {
      this.updateOrderDateTimeCookie();
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.state.cartDetails !== nextProps.cartDetails) {
      this.setState(
        { cartDetails: nextProps.cartDetails, totalItem: nextProps.totalItem, additionalChargeList: nextProps.additionalChargeList, additionalChargeAmount: nextProps.additionalChargeAmount },
        () => {
          this.calculatePrice();
        }
      );
    }
    if (this.state.cartstatus !== nextProps.cartstatus) {
      if (nextProps.cartstatus === "faild") {
        this.props.history.push("/");
      }
    }

    if (this.state.globalSettings !== nextProps.settingsArr) {
      const settingsArr = nextProps.settingsArr;
      const companyEnableRapyd = settingsArr?.companyEnableRapyd ?? false;
      const enableStripe = settingsArr?.companyEnableStripe ?? false;
      const enableOmise = settingsArr?.companyEnableOmise ?? false;
      const companyEnableOmisePayNow = settingsArr?.companyEnableOmisePayNow ?? false;
      

      const companyOmisePublicKey = settingsArr?.companyOmisePublicKey ?? "";
      const omiseKey = companyOmisePublicKey !== "" ? base64.decode(companyOmisePublicKey) : "";
      const companyEnableDeliveryFeeAuto = settingsArr?.companyEnableDeliveryFeeAuto ?? false;

      let paymentMode = "";
      if (companyEnableRapyd === true) {
        paymentMode = "Rapyd";
      } else if (enableStripe === true) {
        paymentMode = "Stripe";
      } else if (enableOmise === true) {
        paymentMode = "Omise";
      } else if (companyEnableOmisePayNow === true) {
        paymentMode = "OmisePayNow";
      }
      
      this.setState(
        {
          globalSettings: settingsArr,
          companyEnableRapyd: companyEnableRapyd,
          enableOmise,
          companyEnableOmisePayNow,
          omiseKey,
          enableStripe,
          paymentMode: paymentMode,
          enableAscentisCRM: settingsArr?.companyEnableAscentisCRM ?? false,
          companyEnableDeliveryFeeAuto: companyEnableDeliveryFeeAuto,
        },
        () => {
          this.calculatePrice();
          if (this.state.enableAscentisCRM === true) {
            this.loadAscentisMember();
          }
        }
      );
    }
  }

  loadZone() {
    Axios.get(`${apiUrl}outletzone/getDetails?zoneID=${this.state.zoneID}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ zoneDetails: res.data.result }, () => {
            this.calculatePrice();
          });
        }
      })
      .catch(() => {});
  }
  loadAscentisMember() {
    Axios.get(`${apiUrl}customer/memberEnquiry?uniqueID=${uniqueID}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        console.log(res.data, "res.datares.datares.data");
        if (res.data.status === "ok") {
          const result = res.data.result;
          const CardLists = result?.CardLists ?? [];
          console.log(CardLists, "CardListsCardListsCardListsCardLists");
          if (CardLists.length > 0) {
            const TotalPointsBAL = parseFloat(CardLists[0].TotalPointsBAL);
            const balanceAscentisPoint = parseFloat(TotalPointsBAL) - parseFloat(this.state.redeemAscentisPoint);
            console.log(balanceAscentisPoint, "balanceAscentisPoint");
            this.setState({ availableAscentisPoint: TotalPointsBAL, balanceAscentisPoint: parseFloat(balanceAscentisPoint).toFixed("2") });
            if (balanceAscentisPoint <= 0) {
              this.setState({ appliedAscentisPoint: false, redeemAscentisPoint: 0 });
              cookie.remove("redeemAscentisPoint", { path: "/" });
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loadCurrentOrder: false });
      });
  }
  loadDeliveryCharge(ordDateTime) {
    this.setState(
      {
        deliveryCharegLoadingStatus: false,
      },
      () => {
        this.calculatePrice();
      }
    );
    if (ordDateTime !== "") {
      this.setState({ deliveryCharegLoadingStatus: true }, () => {
        const postObject = {
          uniqueID,
          postalCode: localStorage.getItem("deliveryPostalCode"),
          unitNumber: this.state.unitNumber,
          floorNumber: this.state.floorNumber,
          outletID: this.state.outletID,
          orderDateTime: new Date(ordDateTime),
        };

        Axios.post(`${apiUrl}delivery/getLalamoveQuote`, postObject)
          .then((res) => {
            if (res.data.status === "ok") {
              this.setState(
                {
                  deliveryCharegLoadingStatus: false,
                  deliveryDatas: res.data.result,
                },
                () => {
                  this.calculatePrice();
                }
              );
            }
          })
          .catch((e) => {
            var errorMsg = e?.response?.data?.message?.errors[0]?.message || e.message;
            this.setState({ deliveryCharegLoadingStatus: false });
            toast.error(errorMsg);
          });
      });
    }
  }

  /* For Advanced Slot */
  updateOrderDateTimeCookie() {
    let orderDateTime__ = cookie.load("orderDateTime") ?? "";
    orderDateTime__ = orderDateTime__ !== "" ? format(new Date(orderDateTime__.replaceAll('"', "")), "yyyy-MM-dd HH:mm") : "";
    var sltdOrdDate = this.state.seleted_ord_date;
    var sltdOrdTime = this.state.seleted_ord_time;

    var OrdDate = format(sltdOrdDate, "yyyy-MM-dd");
    var OrdHours = sltdOrdTime.getHours();
    var OrdMunts = sltdOrdTime.getMinutes();
    var OrdSecnd = sltdOrdTime.getSeconds();
    var ordDateTime = new Date(OrdDate);
    ordDateTime.setHours(OrdHours);
    ordDateTime.setMinutes(OrdMunts);
    ordDateTime.setSeconds(OrdSecnd);

    var deliveryDate = format(sltdOrdDate, "dd/MM/yyyy");
    var deliveryTime = this.pad(OrdHours) + ":" + this.pad(OrdMunts) + ":" + this.pad(OrdSecnd);

    const updatedTime = ordDateTime !== "" ? format(new Date(ordDateTime), "yyyy-MM-dd HH:mm") : "";

    cookie.save("orderDateTime", ordDateTime, { path: "/" });
    cookie.save("deliveryDate", deliveryDate, { path: "/" });
    cookie.save("deliveryTime", deliveryTime, { path: "/" });
    if (this.state.seletedAvilablityId === deliveryId) {
      setTimeout(() => {
        const oldDateTime = this.state.updateTimes;
        const oldDateTime__ = oldDateTime !== "" ? format(new Date(oldDateTime), "yyyy-MM-dd HH:mm") : "";

        const updateDateTime = ordDateTime;
        const updateDateTime__ = updateDateTime !== "" ? format(new Date(updateDateTime), "yyyy-MM-dd HH:mm") : "";

        if (updateDateTime__ !== oldDateTime__ && this.state.deliveryIntitalLoad === true) {
          this.setState({ updateTimes: ordDateTime }, () => {
            if (this.state.companyEnableDeliveryFeeAuto === true) {
              this.loadDeliveryCharge(ordDateTime);
            }
          });
        }

        if (this.state.deliveryIntitalLoad === false && oldDateTime === "") {
          this.setState({ deliveryIntitalLoad: true, updateTimes: ordDateTime }, () => {
            if (this.state.companyEnableDeliveryFeeAuto === true) {
              this.loadDeliveryCharge(ordDateTime);
            }
          });
        }
      }, 1000);
    }

    //var isAdvanced = this.state.isAdvanced;
    var slotType = this.state.slotType;
    var orderSlotVal = "",
      orderSlotTxt = "",
      orderSlotStrTime = "",
      orderSlotEndTime = "";
    if (slotType === "2") {
      orderSlotVal = this.state.seleted_ord_slot;
      orderSlotTxt = this.state.seleted_ord_slotTxt;
      orderSlotStrTime = this.state.seleted_ord_slot_str;
      orderSlotEndTime = this.state.seleted_ord_slot_end;
    }

    cookie.save("orderSlotVal", orderSlotVal, { path: "/" });
    cookie.save("orderSlotTxt", orderSlotTxt, { path: "/" });
    cookie.save("orderSlotStrTime", orderSlotStrTime, { path: "/" });
    cookie.save("orderSlotEndTime", orderSlotEndTime, { path: "/" });
    if (orderDateTime__ !== updatedTime) {
      setTimeout(() => {
        this.props.getCartDetail();
      }, 1000);
    }
  }

  pad(d) {
    return d < 10 ? "0" + d.toString() : d.toString();
  }

  calculatePrice() {
    const cartItem_ = this.state.cartDetails?.cartItem ?? [];
    const additionalChargeAmount = this.state.additionalChargeAmount ?? 0;
    const subtotal = cartItem_.reduce((sum, item) => sum + parseFloat(item.cartItemTotalPrice), 0);
    const isValid = cartItem_.length > 0 ? !cartItem_.some((item) => item.timeValidationError === "Yes") : false;

    const globalSettings = this.state.globalSettings;
    const companyEnableTax = globalSettings?.companyEnableTax ?? false;
    let deliveryCharge = 0;
    let freedeliveryCharge = 0;
    let balancefreedeliveryCharge = 0;
    let freeDeliveryPrecentage = 0;
    if (this.state.seletedAvilablityId === deliveryId) {
      if (this.state.companyEnableDeliveryFeeAuto === true) {
        if (this.state.deliveryDatas !== "") {
          deliveryCharge = this.state.deliveryDatas?.data?.priceBreakdown?.total ?? 0;
        }
      } else {
        if (this.state.companyEnableDeliveryFeeAuto === false) {
          deliveryCharge = this.state.zoneDetails?.zoneDeliveryCharge ?? 0;
          freedeliveryCharge = this.state.zoneDetails?.zoneFreeDelivery ?? 0;
          if (parseFloat(freedeliveryCharge) > 0) {
            balancefreedeliveryCharge = parseFloat(freedeliveryCharge) - parseFloat(subtotal);
            freeDeliveryPrecentage = (parseFloat(subtotal) / parseFloat(freedeliveryCharge)) * 100;
            console.log(parseFloat(freedeliveryCharge), parseFloat(subtotal), parseFloat(freedeliveryCharge), freeDeliveryPrecentage, "freeDeliveryPrecentagefreeDeliveryPrecentage");
          }
          if (parseFloat(freedeliveryCharge) <= parseFloat(subtotal)) {
            deliveryCharge = 0;
          }
        }
      }
    }

    let taxAmount = 0;
    let taxPercentage = 0;
    let taxType = "";
    let addedTotal = parseFloat(subtotal) + parseFloat(additionalChargeAmount) + parseFloat(deliveryCharge);

    if (companyEnableTax === true) {
      const companyEnableTaxPercentage = globalSettings?.companyEnableTaxPercentage ?? 0;
      taxType = globalSettings?.companyTaxType ?? "";
      if (parseFloat(companyEnableTaxPercentage) > 0) {
        taxAmount = taxType === "Inclusive" ? getReverseGST(companyEnableTaxPercentage, addedTotal) : getGstValue(companyEnableTaxPercentage, addedTotal, "format");
        taxPercentage = companyEnableTaxPercentage;
      }
    }

    const discount = this.state.discount;
    const redeemPointAmount = this.state.redeemPointAmount !== "" ? this.state.redeemPointAmount ?? 0 : 0;
    const redeemAscentisPoint = this.state.appliedAscentisPoint ? parseFloat(this.state.redeemAscentisPoint) : 0;

    let grandTotal = parseFloat(subtotal) + parseFloat(additionalChargeAmount) + parseFloat(deliveryCharge) - parseFloat(discount) - parseFloat(redeemPointAmount) - parseFloat(redeemAscentisPoint);
    console.log(grandTotal, "grandTotalgrandTotal");
    if (taxType === "Exclusive") {
      grandTotal = parseFloat(grandTotal) + parseFloat(taxAmount);
    }

    this.setState({
      subtotal: parseFloat(subtotal).toFixed("2"),
      deliveryCharge: parseFloat(deliveryCharge).toFixed("2"),
      taxAmount: parseFloat(taxAmount).toFixed("2"),
      taxPercentage: parseFloat(taxPercentage),
      freedeliveryCharge: parseFloat(freedeliveryCharge).toFixed("2"),
      balancefreedeliveryCharge: parseFloat(balancefreedeliveryCharge).toFixed("2"),
      freeDeliveryPrecentage: parseFloat(freeDeliveryPrecentage).toFixed("2"),
      grandTotal: parseFloat(grandTotal).toFixed("2"),
      taxType: taxType,
      allowToshowCheckout: isValid,
    });
  }
  updateStateValue = (field, value) => {
    this.setState({ [field]: value });
  };
  closeCart(e) {
    e.preventDefault();
    this.props.updateStateValue("openCart", false);
    document.querySelector("body").classList.remove("cart-sidebar-open");
  }
  incDecQty(cartItemQuantity, qtyType, index, itemID, cartItemDetails) {
    showLoader("citem-" + index);

    const cartTotalQuantity =
      this.state.cartDetails !== ""
        ? this.state.cartDetails.cartItem.filter((item) => item.cartItemProductID === cartItemDetails.cartItemProductID).reduce((sum, item) => sum + item.cartItemQuantity, 0)
        : 0;

    if (qtyType === "dec") {
      const productMinimumQuantity = cartItemDetails?.productMinimumQuantity ?? "";
      if (productMinimumQuantity !== "" && productMinimumQuantity !== null && parseInt(productMinimumQuantity) > 0) {
        if (parseInt(cartTotalQuantity) - 1 < parseInt(productMinimumQuantity)) {
          toast.error(`You must order at least ${productMinimumQuantity}`);
          return false;
        }
      }
      cartItemQuantity = parseInt(cartItemQuantity) - 1;
    } else {
      const productMaximumQuantity = cartItemDetails?.productMaximumQuantity ?? "";
      if (productMaximumQuantity !== "" && productMaximumQuantity !== null && parseInt(productMaximumQuantity) > 0) {
        if (parseInt(cartTotalQuantity) + 1 > parseInt(productMaximumQuantity)) {
          toast.error(`You can order up to ${productMaximumQuantity} items`);
          return false;
        }
      }
      cartItemQuantity = parseInt(cartItemQuantity) + 1;
    }
    if (cartItemQuantity > 0) {
      const postObject = {
        uniqueID: uniqueID,
        customerID: this.state.customerID,
        referenceID: "",
        itemQuantity: cartItemQuantity,
      };

      Axios.put(`${apiUrl}cart/${encodeValue(itemID)}`, postObject)
        .then((res) => {
          hideLoader("citem" + index);
          if (res.data.status === "ok") {
            this.props.getCartDetail();
            toast.success(res.data.message);
            this.removePromoItems();
          }
        })
        .catch((e) => {
          hideLoader("citem" + index);
          var errorMsg = e?.response?.data?.message || e.message;
          toast.error(errorMsg);
        });
    } else {
      Axios.delete(`${apiUrl}cart/removeItem/${encodeValue(itemID)}`)
        .then((res) => {
          if (res.data.status === "ok") {
            this.props.getCartDetail();
            toast.warning(res.data.message);
          }
        })
        .catch((e) => {
          var errorMsg = e?.response?.data?.message || e.message;
          toast.error(errorMsg);
        });
    }
  }
  removeItem(itemID, e) {
    e.preventDefault();

    Axios.delete(`${apiUrl}cart/removeItem/${encodeValue(itemID)}`)
      .then((res) => {
        if (res.data.status === "ok") {
          this.props.getCartDetail();
          toast.success(res.data.message);
          this.removePromoItems();
        }
      })
      .catch((e) => {
        var errorMsg = e?.response?.data?.message || e.message;
        toast.error(errorMsg);
      });
  }

  continueProcess = async (e) => {
    e.preventDefault();

    let postObject = this.loadOrderData("Yes");
    showLoader("placeOrder");
    Axios.post(`${apiUrl}order/placeOrder`, postObject, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        if (res.data.status === "ok") {
          this.placeOrder();
        }
      })
      .catch((e) => {
        hideLoader("placeOrder");
        var errorMsg = e?.response?.data?.message || e.message;
        toast.error(parse(errorMsg));
      });
  };

  loadOrderData(validate = "No") {
    /* if  merge order date */
    let orderDate = "";
    const seletedOrdDate = this.state.seleted_ord_date;
    let seletedOrdTime = this.state.seleted_ord_time;

    /* For Advanced Slot */
    var ordSlotStrTm = "",
      ordSlotEndTm = "";
    console.log(seletedOrdDate, seletedOrdTime, "seletedOrdTimeseletedOrdTimeseletedOrdTime");
    if (seletedOrdDate !== "" && seletedOrdTime !== "") {
      var formatedDate = format(seletedOrdDate, "yyyy-MM-dd");
      var OrderHours = seletedOrdTime.getHours();
      var OrderMunts = seletedOrdTime.getMinutes();
      //var OrderSecnd = seletedOrdTime.getSeconds();

      var orderTime = this.pad(OrderHours) + ":" + this.pad(OrderMunts);

      orderDate = formatedDate + " " + orderTime;
      console.log(this.state.isAdvanced);
      console.log(this.state.slotType, this.state.seleted_ord_slot_str, this.state.seleted_ord_slot_end);
      if (this.state.slotType === "2") {
        /* order_is_timeslot = "Yes"; */
        ordSlotStrTm = this.state.seleted_ord_slot_str;
        ordSlotEndTm = this.state.seleted_ord_slot_end;
      }
    }

    if (seletedOrdDate !== "" && seletedOrdTime !== "") {
      const formatedDate_ = format(seletedOrdDate, "yyyy-MM-dd");
      const OrderHours_ = seletedOrdTime.getHours();
      const OrderMunts_ = seletedOrdTime.getMinutes();
      //var OrderSecnd = seletedOrdTime.getSeconds();

      let orderTim_ = this.pad(OrderHours_) + ":" + this.pad(OrderMunts_);

      orderDate = formatedDate_ + " " + orderTim_;
    } else {
      orderDate = cookie.load("orderDateTime");
    }

    if (orderDate === "") {
      toast.error("Please select order date and time.");
      return false;
    }

    let postObject = {
      uniqueID: uniqueID,
      customerID: this.state.customerID,
      outletID: this.state.outletID,
      cartID: this.state.cartDetails._id,
      zoneID: this.state.zoneID,
      availabilityID: this.state.seletedAvilablityId,
      availabilityName: this.state.seletedAvilablityName,
      additionalInformation: this.state.additionalInformation,
      deliveryUnitNumber: this.state.unitNumber,
      deliveryFloorNumber: this.state.floorNumber,
      deliveryAddress: this.state.seletedAvilablityId === deliveryId ? localStorage.getItem("deliveryAddress") ?? "" : "",
      deliveryPostalCode: this.state.seletedAvilablityId === deliveryId ? localStorage.getItem("deliveryPostalCode") ?? "" : "",
      billingUnitNumber: this.state.seletedAvilablityId === deliveryId ? (this.state.sameAsDeliveryAddress ? this.state.unitNumber : this.state.billingUnitNumber) : "",
      billingFloorNumber: this.state.seletedAvilablityId === deliveryId ? (this.state.sameAsDeliveryAddress ? this.state.floorNumber : this.state.billingFloorNumber) : "",
      billingAddress: this.state.seletedAvilablityId === deliveryId ? (this.state.sameAsDeliveryAddress ? localStorage.getItem("deliveryAddress") : this.state.billingAddress) ?? "" : "",
      billingPostalCode: this.state.seletedAvilablityId === deliveryId ? (this.state.sameAsDeliveryAddress ? localStorage.getItem("deliveryPostalCode") : this.state.billingPostalCode) ?? "" : "",
      orderDate: orderDate,
      orderDateType: this.state.slotType,
      orderSlotStart: ordSlotStrTm,
      orderSlotEnd: ordSlotEndTm,
      subTotal: this.state.subtotal,
      deliveryCharge: this.state.deliveryCharge,
      additionalChargeAmount: this.state.additionalChargeAmount,
      additionalChargeList: this.state.additionalChargeList.length > 0 ? JSON.stringify(this.state.additionalChargeList) : "",
      grandTotal: this.state.grandTotal,
      discountApplied: this.state.discountApplied,
      promoCode: this.state.promoCode,
      promoFreeDelivery: this.state.promoFreeDelivery,
      discount: this.state.discount,
      redeemPoint: parseFloat(this.state.redeemPointAmount) > 0 ? this.state.redeemPoint : "",
      redeemPointAmount: parseFloat(this.state.redeemPointAmount) > 0 ? this.state.redeemPointAmount : 0,
      appliedAscentisPoint: this.state.appliedAscentisPoint ? "Yes" : "No",
      redeemAscentisPoint: this.state.appliedAscentisPoint && parseFloat(this.state.redeemAscentisPoint) > 0 ? this.state.redeemAscentisPoint : 0,
      paymentMode: this.state.paymentMode,
      paymentGetwayName: "",
      orderSource: "Web",
      validate: validate,
      deliveryDatas: this.state.deliveryDatas !== "" ? JSON.stringify(this.state.deliveryDatas) : "",
      sendAsGift: this.state.sendAsGift ? "Yes" : "No",
      recipientName: this.state.recipientName,
      recipientContactNo: this.state.recipientContactNo,
      recipientMessage: this.state.recipientMessage,
    };
    if (this.state.paymentMode === "Rapyd" || this.state.paymentMode === "Stripe") {
      postObject.callbackurl = mainUrl;
    }
    console.log(postObject, "postObjectpostObjectpostObjectpostObject");
    return postObject;
  }

  placeOrder = async (e) => {
    let postObject = this.loadOrderData();
    console.log(postObject, "postObjectpostObject");

    showLoader("placeOrder");
    if (this.state.paymentMode === "Rapyd") {
      Axios.post(apiUrl + "payment/processRapydPayment", postObject, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
        .then((res) => {
          hideLoader("placeOrder");
          console.log(res.data, "res.data");
          if (res.data.status === "ok") {
            localStorage.setItem("paymentRequestIdRapyd", res.data.payment_requestId);
            window.location.href = res.data.redirectURL;
          } else {
            Swal.fire({
              title: "Error",
              html: res.data.message,
              icon: "error",
              customClass: {
                confirmButton: "btn btn-primary waves-effect waves-light",
              },
              buttonsStyling: false,
            });
          }
        })
        .catch((e) => {
          var errorMsg = e?.response?.data?.message || e.message;
          Swal.fire({
            title: "Error",
            html: errorMsg,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary waves-effect waves-light",
            },
            buttonsStyling: false,
          });
          hideLoader("placeOrder");
          console.error("Error fetching data:", e);
        });
    } else if (this.state.paymentMode === "Stripe") {
      Axios.post(`${apiUrl}payment/createpaymentintent`, postObject, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
        .then((res) => {
          hideLoader("placeOrder");
          if (res.data.status === "ok") {
            localStorage.setItem("paymentRequestIdStripe", res.data.payment_requestId);
            window.location.href = res.data.redirectURL;
          } else {
            Swal.fire({
              title: "Error",
              html: res.data.message,
              icon: "error",
              customClass: {
                confirmButton: "btn btn-primary waves-effect waves-light",
              },
              buttonsStyling: false,
            });
          }
        })
        .catch((e) => {
          hideLoader("placeOrder");
          var errorMsg = e?.response?.data?.message || e.message;
          toast.error(errorMsg);
        });
    } else if (this.state.paymentMode === "Omise") {
      hideLoader("placeOrder");
      if (this.state.omiseKey !== "") {
        this.setState({ openomisePopup: true });
      }
    } else if (this.state.paymentMode === "OmisePayNow") {
      hideLoader("placeOrder");
      let postObject = this.loadOrderData();
      Axios.post(apiUrl + "payment/processOmisePayNowPayment", postObject, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
        .then((res) => {
          hideLoader("prcessOmise");
          console.log(res.data, "res.data");
          if (res.data.status === "ok") {
            const response = res.data;
            this.setState({ openomisePayNowRefID:response?.payment_requestId, openomisePayNowPopup: true, omisePayNowQRCode: response?.QRCode, omisePayNowBalanceTime: 600 }, ()=> {
              startTimePay = setInterval(() => {
                  var modTime = this.state.omisePayNowBalanceTime % 3;
                  if (this.state.omisePayNowBalanceTime > 1) {
                    if (modTime === 0) {
                      this.checkOmisePayNowPamentStatus(startTimePay);
                    }
                    this.omisePaynowTimeReduce();
                  } else {

                    clearInterval(startTimePay);
                    this.setState({openomisePayNowPopup:false}, ()=> {
                      Swal.fire({
                        title: "Error",
                        html: "This PayNow QR code has expired. Please generate a new one.",
                        icon: "error",
                        customClass: {
                          confirmButton: "btn btn-primary waves-effect waves-light",
                        },
                        buttonsStyling: false,
                      });
                    })
                    
                  }
                }, 1000);
            });
          } else {
            Swal.fire({
              title: "Error",
              html: res.data.message,
              icon: "error",
              customClass: {
                confirmButton: "btn btn-primary waves-effect waves-light",
              },
              buttonsStyling: false,
            });
          }
        })
        .catch((e) => {
          var errorMsg = e?.response?.data?.message || e.message;

          clearInterval(startTimePay);
          this.setState({openomisePayNowPopup:false}, ()=> {
            Swal.fire({
              title: "Error",
              html: errorMsg,
              icon: "error",
              customClass: {
                confirmButton: "btn btn-primary waves-effect waves-light",
              },
              buttonsStyling: false,
            });
          })
          hideLoader("prcessOmise");
          console.error("Error fetching data:", e);
        });
    } else {
      Axios.post(`${apiUrl}order/placeOrder`, postObject, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
        .then((res) => {
          if (res.data.status === "ok") {
            this.props.getCartDetail();
            toast.success(res.data.message);
          }
        })
        .catch((e) => {
          hideLoader("placeOrder");
          var errorMsg = e?.response?.data?.message || e.message;
          toast.error(errorMsg);
        });
    }
  };

  omisePaynowTimeReduce() {
    var omisePayNowBalanceTime = parseInt(this.state.omisePayNowBalanceTime) - 1;
    this.setState({ omisePayNowBalanceTime});
  }
  checkOmisePayNowPamentStatus(startTimePay) {    
          const customerID = localStorage.getItem("customerID") ?? "";
          const postObject = {
            uniqueID,
            payment_refID: this.state.openomisePayNowRefID,
            customerID,
          };
          Axios
            .post(apiUrl + "payment/checkStatusOmise", postObject, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            })
            .then((res) => {
              if (res.data.status === "ok") {
                clearInterval(startTimePay);
                var msg = "Order has been successfully placed.";
                Swal.fire({
                  title: "Success",
                  html: msg,
                  icon: "success",
                  customClass: {
                    confirmButton: "btn btn-primary waves-effect waves-light",
                  },
                  buttonsStyling: false,
                });
    
                this.props.history.push(`/thankyou/${res.data.orderNumber}`);
              } else if (res.data.status === "error") {
                 /* clearInterval(startTimePay);
                  this.setState({openomisePayNowPopup:false}, ()=> {
                    Swal.fire({
                      title: "Error",
                      html: res.data.message,
                      icon: "error",
                      customClass: {
                        confirmButton: "btn btn-primary waves-effect waves-light",
                      },
                      buttonsStyling: false,
                    });
                  });
                  this.props.history.push("/"); */
              }
            })
            .catch((e) => {
              /*  clearInterval(startTimePay);
               var errorMsg = e?.response?.data?.message || e.message;
               this.setState({openomisePayNowPopup:false}, ()=> {
                Swal.fire({
                  title: "Error",
                  html: errorMsg,
                  icon: "error",
                  customClass: {
                    confirmButton: "btn btn-primary waves-effect waves-light",
                  },
                  buttonsStyling: false,
                });
                console.error("Error fetching data:", e);
              }); */
          })
  }

  handleChangeTxt = (item, event) => {
    const re = /^[0-9 \b]+$/;
    if (item === "cardNumber") {
      if (event.target.value === "" || re.test(event.target.value)) {
        var cardnumber = this.space(event.target.value);
        var cardnumberLenght = cardnumber.length;
        if (cardnumberLenght <= 19) {
          this.setState({ [item]: cardnumber });
          this.cardValidation(cardnumber);
        }
      }
    } else if (item === "expiration_month" || item === "expiration_year" || item === "security_code") {
      if (event.target.value === "" || re.test(event.target.value)) {
        this.setState({ [item]: event.target.value });
      }
    } else if (item.indexOf("otp") >= 0) {
      const value = event.target.value;
      this.setState({ [item]: "" }, () => {
        this.setState({ [item]: value, [`${item}Error`]: "" });
      });
      var lastFive = item.slice(-1);

      if (lastFive === "1") {
        if (value === "") {
          this.otp1Ref.current?.focus();
        } else {
          this.otp2Ref.current?.focus();
        }
      } else if (lastFive === "2") {
        if (value === "") {
          this.otp1Ref.current?.focus();
        } else {
          this.otp3Ref.current?.focus();
        }
      } else if (lastFive === "3") {
        if (value === "") {
          this.otp2Ref.current?.focus();
        } else {
          this.otp4Ref.current?.focus();
        }
      } else if (lastFive === "4") {
        if (value === "") {
          this.otp3Ref.current?.focus();
        } else {
          this.otp5Ref.current?.focus();
        }
      } else if (lastFive === "5") {
        if (value === "") {
          this.otp4Ref.current?.focus();
        } else {
          this.otp6Ref.current?.focus();
        }
      } else if (lastFive === "6") {
        if (value === "") {
          this.otp5Ref.current?.focus();
        } else {
          this.otp6Ref.current?.focus();
        }
      }
    } else {
      this.setState({ [item]: event.target.value });
    }

    this.setState({
      omisenameerror: "",
      omisecardrror: "",
      omisemontherror: "",
      omiseyearerror: "",
      omisesecurity_codeerror: "",
    });
  };

  onPasteCaptureHandler(e) {
    var clipboardData, pastedData;

    // Stop data actually being pasted into div
    e.stopPropagation();
    e.preventDefault();

    // Get pasted data via clipboard API
    clipboardData = e.clipboardData || window.clipboardData;
    pastedData = clipboardData.getData("Text");

    // Do whatever with pasteddata
    if (pastedData !== "") {
      var split = pastedData.split("");
      this.setState({ otp1: split[0] });
      this.setState({ otp2: split[1] });
      this.setState({ otp3: split[2] });
      this.setState({ otp4: split[3] });
      this.setState({ otp5: split[4] });
      this.setState({ otp6: split[5] });
    }
  }

  space(el) {
    var numbes = el.replace(/ /g, "");
    return numbes.replace(/(\d{4})/g, "$1 ").replace(/(^\s+|\s+$)/, "");
  }

  cardValidation(carnumber) {
    var imagename = "";
    if (carnumber !== "") {
      var single = carnumber.substring(0, 1);
      var double = carnumber.substring(0, 2);

      if (single === 4) {
        imagename = "visa";
      } else if (double === 34 || double === 37) {
        imagename = "american";
      } else if (double >= 51 && double <= 55) {
        imagename = "master";
      } else if (double === 60 || double === 64 || double === 65) {
        imagename = "discover";
      }
    }
    console.log(imagename, "imagenameimagenameimagename");
    this.setState({ cardImage: imagename });
  }

  generateOmiseToken() {
    if (this.state.omiseKey !== "") {
      var errorFlg = 0,
        omisenameerror = "",
        omisecardrror = "",
        omisemontherror = "",
        omiseyearerror = "",
        omisecodeerror = "";
      if (this.state.holdername === "") {
        errorFlg++;
        omisenameerror = "omise-form-error";
      }
      if (this.state.cardNumber === "") {
        errorFlg++;
        omisecardrror = "omise-form-error";
      }
      if (this.state.expiration_month === "") {
        errorFlg++;
        omisemontherror = "omise-form-error";
      }
      if (this.state.expiration_year === "") {
        errorFlg++;
        omiseyearerror = "omise-form-error";
      }
      if (this.state.security_code === "") {
        errorFlg++;
        omisecodeerror = "omise-form-error";
      }

      this.setState({
        omisenameerror: omisenameerror,
        omisecardrror: omisecardrror,
        omisemontherror: omisemontherror,
        omiseyearerror: omiseyearerror,
        omisecodeerror: omisecodeerror,
      });
      console.log(errorFlg, "errorFlgerrorFlgerrorFlg");
      if (errorFlg === 0) {
        showLoader("prcessOmise");
        window.Omise.setPublicKey(this.state.omiseKey);
        var card = {
          name: this.state.holdername,
          number: this.state.cardNumber,
          expiration_month: this.state.expiration_month,
          expiration_year: this.state.expiration_year,
          security_code: this.state.security_code,
          livemode: false,
        };
        const self = this;
        window.Omise.createToken("card", card, function (statusCode, response) {
          // hideLoader("omise-pay-btn", "class");
          console.log(response, "responseresponseresponse");
          if (statusCode === 200) {
            let postObject = self.loadOrderData();
            postObject.token = response.id;
            postObject.callbackurl = mainUrl;
            Axios.post(apiUrl + "payment/processOmisePayment", postObject, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            })
              .then((res) => {
                hideLoader("prcessOmise");
                console.log(res.data, "res.data");
                if (res.data.status === "ok") {
                  localStorage.setItem("paymentRequestIdOmise", res.data.payment_requestId);
                  window.location.href = res.data.redirectURL;
                } else {
                  Swal.fire({
                    title: "Error",
                    html: res.data.message,
                    icon: "error",
                    customClass: {
                      confirmButton: "btn btn-primary waves-effect waves-light",
                    },
                    buttonsStyling: false,
                  });
                }
              })
              .catch((e) => {
                var errorMsg = e?.response?.data?.message || e.message;
                Swal.fire({
                  title: "Error",
                  html: errorMsg,
                  icon: "error",
                  customClass: {
                    confirmButton: "btn btn-primary waves-effect waves-light",
                  },
                  buttonsStyling: false,
                });
                hideLoader("prcessOmise");
                console.error("Error fetching data:", e);
              });
          } else {
            const errorMsgs = response?.message ?? "Something is wrong try again";
            Swal.fire({
              title: "Error",
              html: errorMsgs,
              icon: "error",
              customClass: {
                confirmButton: "btn btn-primary waves-effect waves-light",
              },
              buttonsStyling: false,
            });
            hideLoader("prcessOmise");
          }
        });
      }
    }
  }

  /* For Advanced Slot */
  setdateTimeFlg = (field, value) => {
    if (field === "tmflg") {
      this.setState({ getDateTimeFlg: value });
    } else if (field === "ordDate") {
      let ordTime = "";
      $(".ordrdatetime_error").html("");
      this.setState({
        seleted_ord_date: value,
        seleted_ord_time: ordTime,
        seleted_ord_slot: ordTime,
        seleted_ord_slotTxt: ordTime,
        seleted_ord_slot_str: ordTime,
        seleted_ord_slot_end: ordTime,
      });
    } else if (field === "ordTime") {
      let tmSltArr = value;
      let ordTime = "";
      $(".ordrdatetime_error").html("");
      this.setState({
        seleted_ord_time: tmSltArr["startTime"],
        seleted_ord_slot: ordTime,
        seleted_ord_slotTxt: ordTime,
        seleted_ord_slot_str: ordTime,
        seleted_ord_slot_end: ordTime,
      });
      let OrdDateTimeArr = [];
      OrdDateTimeArr["OrdDate"] = tmSltArr["sldorddate"];
      OrdDateTimeArr["OrdTime"] = tmSltArr["sldordtime"];
    } else if (field === "ordSlotDate") {
      let ordTime = "";
      $(".ordrdatetime_error").html("");
      this.setState({
        seleted_ord_date: value,
        seleted_ord_time: ordTime,
        seleted_ord_slot: ordTime,
        seleted_ord_slotTxt: ordTime,
        seleted_ord_slot_str: ordTime,
        seleted_ord_slot_end: ordTime,
      });
    } else if (field === "ordSlotTime") {
      let tmSltArr = value;
      $(".ordrdatetime_error").html("");
      this.setState({
        seleted_ord_time: tmSltArr["startTime"],
        seleted_ord_slot: tmSltArr["ordSlotVal"],
        seleted_ord_slotTxt: tmSltArr["ordSlotLbl"],
        seleted_ord_slot_str: tmSltArr["ordSlotStr"],
        seleted_ord_slot_end: tmSltArr["ordSlotEnd"],
      });
      let OrdDateTimeArr_ = [];
      OrdDateTimeArr_["OrdDate"] = tmSltArr["sldorddate"];
      OrdDateTimeArr_["OrdTime"] = tmSltArr["sldordtime"];
    }
  };

  handleChange(name, e) {
    let value = e.target.value;
    if (name === "additionalInformation" || name === "recipientMessage") {
      value = value.replace(/[^0-9a-zA-Z,[\](){}$&\-. ]/g, "");
    }
    this.setState({ [name]: value }, () => {
      if (name === "billingPostalCode") {
        if (value.length === 6) {
          this.loadZipcodeDetails();
        }
      }
    });
  }
  handleChangeCheckBox(name, e) {
    this.setState({ [name]: e.target.checked });
  }

  loadZipcodeDetails() {
    Axios.get(`${apiUrl}setting/getZipcodeDetails?zipCode=${this.state.billingPostalCode}`)
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
          const zip_buno = result?.zip_buno ?? "";
          let zip_sname = result?.zip_sname ?? "";
          if (zip_buno !== "" && zip_buno !== null) {
            zip_sname = `${zip_buno}, ${zip_sname}`;
          }
          this.setState({ billingAddress: zip_sname });
        }
      })
      .catch(() => {});
  }

  applyPromoCode() {
    if (this.state.promoCode !== "") {
      if (this.state.discountApplied === "Yes") {
        this.removePromoItems();
      } else {
        showLoader("applyPromo");
        const postObject = {
          uniqueID,
          customerID: this.state.customerID,
          promoCode: this.state.promoCode,
          subTotal: this.state.subtotal,
          availabilityID: this.state.seletedAvilablityId,
          cartID: this.state.cartDetails._id,
        };

        Axios.post(`${apiUrl}promotion/applypromo`, postObject, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
          .then((res) => {
            hideLoader("applyPromo");
            if (res.data.status === "ok") {
              toast.success(res.data.message);
              this.setState(
                {
                  discountApplied: "Yes",
                  discount: res.data.promotionAmount,
                  promoFreeDelivery: res.data.promoFreeDelivery === true ? "Yes" : "No",
                  redeemPoint: "",
                  redeemPointAmount: "",
                },
                () => {
                  cookie.save("discountApplied", "Yes", { path: "/" });
                  cookie.save("promoFreeDelivery", res.data.promoFreeDelivery === true ? "Yes" : "No", { path: "/" });
                  cookie.save("discount", res.data.promotionAmount, {
                    path: "/",
                  });
                  cookie.save("promoCode", this.state.promoCode, { path: "/" });

                  cookie.remove("redeemPoint", { path: "/" });
                  cookie.remove("redeemPointAmount", { path: "/" });
                  this.calculatePrice();
                }
              );
            }
          })
          .catch((e) => {
            hideLoader("applyPromo");
            var errorMsg = e?.response?.data?.message ?? e.message;
            toast.error(errorMsg);
            this.calculatePrice();
          });
      }
    } else {
      toast.error("Please enter point");
    }
  }

  applyRedeemPoints() {
    if (parseFloat(this.state.redeemPoint) > 0) {
      if (parseFloat(this.state.redeemPointAmount) > 0) {
        this.setState({ redeemPoint: "", redeemPointAmount: "" }, () => {
          cookie.remove("redeemPoint", { path: "/" });
          cookie.remove("redeemPointAmount", { path: "/" });
          this.calculatePrice();
        });
      } else {
        showLoader("applyRedeemPoints");
        const postObject = {
          uniqueID,
          redeemPoint: this.state.redeemPoint,
        };

        Axios.post(`${apiUrl}order/redeemPoint`, postObject, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
          .then((res) => {
            hideLoader("applyRedeemPoints");
            if (res.data.status === "ok") {
              this.setState({ OTPPopup: true });
              /*  toast.success(res.data.message);
              const result = res.data.result;
              this.removePromoItems();
              this.setState(
                {
                  redeemPoint: result.applicablePoints,
                  redeemPointAmount: result.redeemAmount,
                },
                () => {
                  cookie.save("redeemPoint", result.applicablePoints, {
                    path: "/",
                  });
                  cookie.save("redeemPointAmount", result.redeemAmount, {
                    path: "/",
                  });
                  this.calculatePrice();
                }
              ); */
            }
          })
          .catch((e) => {
            hideLoader("applyRedeemPoints");
            var errorMsg = e?.response?.data?.message || e.message;
            toast.error(errorMsg);
          });
      }
    } else {
      toast.error("Please enter point");
    }
  }
  maskEmail(email) {
    if (email !== "") {
      const [username, domain] = email.split("@"); // Split email into username & domain
      if (username.length <= 3) {
        return `${username[0]}***@${domain}`; // If username is short, show only first letter
      }
      return `${username.substring(0, 3)}******@${domain}`; // Mask after first 3 chars
    }
  }
  resetOTP() {}
  confirmOTP() {
    const otp = `${this.state.otp1}${this.state.otp2}${this.state.otp3}${this.state.otp4}${this.state.otp5}${this.state.otp6}`;
    if (otp.length === 6) {
      if (parseFloat(this.state.redeemPoint) > 0) {
        if (parseFloat(this.state.redeemPointAmount) > 0) {
          this.setState({ redeemPoint: "", redeemPointAmount: "" }, () => {
            cookie.remove("redeemPoint", { path: "/" });
            cookie.remove("redeemPointAmount", { path: "/" });
          });
        } else {
          showLoader("verifyOTP");

          const postObject = {
            uniqueID,
            redeemPoint: this.state.redeemPoint,
            otp: otp,
          };

          Axios.post(`${apiUrl}order/redeemPointVerifyOTP`, postObject, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          })
            .then((res) => {
              hideLoader("verifyOTP");
              if (res.data.status === "ok") {
                this.setState({ OTPPopup: false });
                toast.success(res.data.message);
                const result = res.data.result;
                this.removePromoItems();
                this.setState(
                  {
                    redeemPoint: result.applicablePoints,
                    redeemPointAmount: result.redeemAmount,
                  },
                  () => {
                    cookie.save("redeemPoint", result.applicablePoints, {
                      path: "/",
                    });
                    cookie.save("redeemPointAmount", result.redeemAmount, {
                      path: "/",
                    });
                    this.calculatePrice();
                  }
                );
              }
            })
            .catch((e) => {
              hideLoader("verifyOTP");
              var errorMsg = e?.response?.data?.message || e.message;
              toast.error(errorMsg);
            });
        }
      } else {
        toast.error("Please enter point");
      }
    } else {
      toast.error("Please enter OTP");
    }
  }

  applyRedeemAscentisPoints() {
    if (parseFloat(this.state.redeemAscentisPoint) > 0) {
      if (this.state.appliedAscentisPoint) {
        this.setState(
          { appliedAscentisPoint: false, redeemAscentisPoint: 0 },
          () => {
            cookie.remove("redeemAscentisPoint", { path: "/" });
          },
          () => {
            this.calculatePrice();
          }
        );
      } else {
        const redeemAscentisPoint = this.state.redeemAscentisPoint;
        const availableAscentisPoint = this.state.availableAscentisPoint;
        if (parseFloat(redeemAscentisPoint) <= parseFloat(availableAscentisPoint)) {
          this.setState({ appliedAscentisPoint: true }, () => {
            this.calculatePrice();
          });
          cookie.save("redeemAscentisPoint", this.state.redeemAscentisPoint, { path: "/" });
          toast.success(`Redeem points applied successfully.`);
        } else {
          toast.error(`You can't redeem points because you only have ${availableAscentisPoint} points.`);
          this.calculatePrice();
        }
      }
    } else {
      toast.error("Please enter point");
    }
  }

  removePromoItems() {
    this.setState(
      {
        discountApplied: "No",
        discount: 0,
        promoFreeDelivery: "No",
        promoCode: "",
      },
      () => {
        cookie.remove("discountApplied", { path: "/" });
        cookie.remove("promoCode", { path: "/" });
        cookie.remove("promoFreeDelivery", { path: "/" });
        cookie.remove("discount", { path: "/" });
        this.calculatePrice();
      }
    );
  }
  setOpen(open) {
    this.setState({ open });
  }
  selectPaymentMode(paymentMode) {
    this.setState({ paymentMode });
  }

  render() {
    const cartItem = this.state.cartDetails?.cartItem ?? [];
    return (
      <div className="cover">
        <Header trigerCart={this.state.trigerCart} updateStateValue={this.updateStateValue.bind(this)} loginPopup={this.state.loginPopup} />
        <div className="checkout-blankpage">
          <div className="container">
            <div className="continue-link cl-top">
              <Link to={"/products"}>Continue Shopping</Link>
            </div>

            <div className="checkout-grid">
              <div className="checkout-lhs">
                {this.state.deliveryCharegLoadingStatus === true && (
                  <div className="overlay" id="loaderOverlay">
                    <div className="delivery-loader-main">
                      <div className="loader-container">
                        <div className="box">
                          <img src={logo} alt="logo" />
                        </div>
                        <div className="progress-bar">
                          <div className="progress"></div>
                        </div>
                        <p className="text">Checking delivery charges...</p>
                      </div>
                    </div>
                  </div>
                )}
                <div className="appendix textcenter">
                  <h5>You're placing an order from</h5>
                  <p>
                    <b>{this.state.outletName}</b> for <b>{this.state.seletedAvilablityName}</b> on <b>{this.state.displyDate}</b> at{" "}
                    <b>{showOrderTime(this.state.seleted_ord_time, this.state.seleted_ord_slot_str, this.state.seleted_ord_slot_end, this.state.slotType)}</b>
                  </p>
                </div>

                <div className="checkout-index">
                  {this.state.seletedAvilablityId === deliveryId ? (
                    <div className="checkout-index-top">
                      <h4>Delivery Details</h4>
                      <div className="da-order-merge-column">
                        <div className={`da-order-two-handling ${this.state.seletedAvilablityId === deliveryId ? "delivery-outlet" : "pickup-outlet da-order-single-handling-outlet"}`}>
                          <div className={`da-order-two-handling-lhs`}>
                            <h5>{this.state.seletedAvilablityId === pickupId ? "Takeaway Outlet" : "Outlet"}</h5>
                            <strong>{this.state.outletName}</strong>
                            <p>{this.state.orderHandledOutlet}</p>
                          </div>
                          <div className="da-order-two-handling-rhs">
                            {this.state.seletedAvilablityId === deliveryId && (
                              <React.Fragment>
                                <h5>Delivery Location</h5>
                                <p>{addressFormat(this.state.unitNumber, this.state.floorNumber, localStorage.getItem("deliveryAddress"), localStorage.getItem("deliveryPostalCode"), CountryName)}</p>
                              </React.Fragment>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="checkout-contact-form">
                        <h3>Billing Address</h3>
                        <div className="checkout-recipient-form">
                          <div className="single-grid">
                            <div className="form-group">
                              <input type="checkbox" className="checkbox-control" onChange={this.handleChangeCheckBox.bind(this, "sameAsDeliveryAddress")} checked={this.state.sameAsDeliveryAddress} />
                              <label>Same As Delivery Address</label>
                            </div>
                          </div>
                        </div>
                        {!this.state.sameAsDeliveryAddress && (
                          <div>
                            <div className="two-col-grid">
                              <div className="form-group">
                                <input type="text" className="form-control" placeholder="Postal Code" onChange={this.handleChange.bind(this, "billingPostalCode")} />
                              </div>
                              <div className="form-group">
                                <input type="text" className="form-control" placeholder="Address" onChange={this.handleChange.bind(this, "billingAddress")} value={this.state.billingAddress} />
                              </div>
                            </div>
                            <div className="two-col-grid">
                              <div className="form-group">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Unit Number"
                                  onChange={this.handleChange.bind(this, "billingUnitNumber")}
                                  value={this.state.billingUnitNumber}
                                />
                              </div>
                              <div className="form-group">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Floor Number"
                                  onChange={this.handleChange.bind(this, "billingFloorNumber")}
                                  value={this.state.billingFloorNumber}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="checkout-index-top">
                      <h4>Takeaway Store Address</h4>
                      <div className="checkout-pickup-store-merge">
                        <div className="checkout-pickup-store-name">
                          <span>Store Name </span>
                          <h4>{this.state.outletName}</h4>
                        </div>
                        <div className="checkout-pickup-store-address">
                          <span>Store Address</span>

                          <p>{this.state.orderHandledOutlet}</p>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="checkout-index-center">
                    <div className="checkout-contact-form">
                      <div className="select-delivery-slot-header">
                        <h3>Choose Date & Time</h3>
                      </div>
                      <OrderAdvancedDatetimeSlot
                        {...this.props}
                        hdrState={this.state}
                        setdateTimeFlg={this.setdateTimeFlg.bind(this)}
                        indutualText={true}
                        labelDateName={`${this.state.labelDateName} Date`}
                        labelTimeName={`${this.state.labelTimeName} Time`}
                        outletID={this.state.outletID}
                      />
                    </div>
                    {this.state.seletedAvilablityId === deliveryId && (
                      <div className="checkout-recipient-form">
                        <h4>Recipients</h4>
                        <div className="single-grid">
                          <div className="form-group">
                            <input type="checkbox" className="checkbox-control" onChange={this.handleChangeCheckBox.bind(this, "sendAsGift")} checked={this.state.sendAsGift} />
                            <label>I would like to send this order as a gift</label>
                          </div>
                        </div>
                        {this.state.sendAsGift && (
                          <>
                            <div className="two-col-grid">
                              <div className="form-group">
                                <input type="text" className="form-control" placeholder="Recipient Name" onChange={this.handleChange.bind(this, "recipientName")} />
                              </div>
                              <div className="form-group">
                                <input type="text" className="form-control" placeholder="Recipient Phone" name="recipientContactNo" onChange={this.handleChange.bind(this, "recipientContactNo")} />
                              </div>
                            </div>
                            <div className="single-grid">
                              <div className="form-group">
                                <textarea
                                  placeholder="Please enter your gift message here..."
                                  value={this.state.recipientMessage}
                                  onChange={this.handleChange.bind(this, "recipientMessage")}
                                ></textarea>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="checkout-index-btm">
                    <h3>Additional Information</h3>

                    <div className="single-grid">
                      <div className="form-group">
                        <textarea
                          placeholder="Enter any order related instructions here"
                          value={this.state.additionalInformation}
                          onChange={this.handleChange.bind(this, "additionalInformation")}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="redeem-promo-together">
                    {this.state.enableAscentisCRM === true ? (
                      <div className="checkout-reddeem-area">
                        <h6>Redeem Points </h6>
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Points"
                            value={this.state.redeemAscentisPoint > 0 ? this.state.redeemAscentisPoint : ""}
                            onChange={this.handleChange.bind(this, "redeemAscentisPoint")}
                            readOnly={this.state.appliedAscentisPoint}
                          />
                          <button className="button" id="redeemAscentisPoint" onClick={this.applyRedeemAscentisPoints.bind(this)}>
                            {this.state.appliedAscentisPoint ? "Remove" : "Apply"}
                          </button>
                        </div>
                        <div className="you-have">
                          You have <strong>{this.state.balanceAscentisPoint ?? 0}</strong> points
                        </div>
                      </div>
                    ) : (
                      this.state.globalSettings?.companyEnableLoyalty === true && (
                        <div className="checkout-reddeem-area">
                          <h6>Redeem Points </h6>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Points"
                              value={this.state.redeemPoint}
                              onChange={this.handleChange.bind(this, "redeemPoint")}
                              readOnly={parseFloat(this.state.redeemPointAmount) > 0 ? true : false}
                            />
                            <button className="button" id="applyRedeemPoints" onClick={this.applyRedeemPoints.bind(this)}>
                              {parseFloat(this.state.redeemPointAmount) > 0 ? "Remove" : "Apply"}
                            </button>
                          </div>
                          <div className="you-have">
                            You have <strong>{this.state.globalSettings?.customer?.customerAvailablePoints ?? 0}</strong> points
                          </div>
                          <div className="you-have-note">
                            <em>
                              Note: <strong>{this.state.globalSettings?.companyLoyaltyRedeemPoints ?? ""}</strong> points ={" "}
                              <strong>{showPriceDirect(this.state.globalSettings?.companyLoyaltyRedeemAmount ?? "")}</strong>
                            </em>
                          </div>
                        </div>
                      )
                    )}
                    <div className="checkout-promo-area">
                      <h6>Promo Code</h6>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Promo Code"
                          value={this.state.promoCode}
                          onChange={this.handleChange.bind(this, "promoCode")}
                          readOnly={this.state.discountApplied === "Yes" ? true : false}
                        />
                        <button className="button" onClick={this.applyPromoCode.bind(this)} id="applyPromo">
                          {this.state.discountApplied === "Yes" ? "Remove" : "Apply"}
                        </button>
                      </div>
                      {/* <div className="you-have">
                        You have <strong>2</strong> Promotions
                      </div> */}
                    </div>
                  </div>
                  <div className="checkout-payment-area">
                    <h3>Payment method</h3>
                    <ul>
                      {this.state.companyEnableRapyd === true && (
                        <li className={`${this.state.paymentMode === "Rapyd" ? "active" : ""}`} onClick={this.selectPaymentMode.bind(this, "Rapyd")}>
                          <div className="radio-round"></div>
                          <span>Credit card or Debit Card</span>
                        </li>
                      )}
                      {this.state.enableStripe === true && (
                        <li className={`${this.state.paymentMode === "Stripe" ? "active" : ""}`} onClick={this.selectPaymentMode.bind(this, "Stripe")}>
                          <div className="radio-round"></div>
                          <span>Credit card or Debit Card</span>
                        </li>
                      )}
                      {this.state.enableOmise === true && (
                        <li className={`${this.state.paymentMode === "Omise" ? "active" : ""}`} onClick={this.selectPaymentMode.bind(this, "Omise")}>
                          <div className="radio-round"></div>
                          <span>Credit card or Debit Card (Omise)</span>
                        </li>
                      )}
                      {this.state.companyEnableOmisePayNow === true && (
                        <li className={`${this.state.paymentMode === "OmisePayNow" ? "active" : ""}`} onClick={this.selectPaymentMode.bind(this, "OmisePayNow")}>
                          <div className="radio-round"></div>
                          <span>Credit card or Debit Card (Omise PayNow)</span>
                        </li>
                      )}
                      {/* <li>
                        <div className="radio-round"></div>
                        <span>Pay by Cash</span>
                      </li> */}
                    </ul>
                  </div>
                  {this.state.paymentMode !== "" && this.state.allowToshowCheckout && (
                    <div className="single-button-grid final-button">
                      <a href="/" className="button" id="placeOrder" onClick={this.continueProcess.bind(this)}>
                        Checkout Now
                      </a>
                    </div>
                  )}
                </div>
              </div>
              <div className="checkout-sidebar">
                {cartItem.length > 0 && (
                  <React.Fragment>
                    <div className="checkout-sidebar-header">
                      <span>Items</span>
                      <a href="/">Clear Items</a>
                    </div>
                    <div className="items-scroll">
                      {cartItem.map((item, index) => {
                        return (
                          <div className="items-row-parent" key={index} id={`citem${index}`}>
                            <div className="items-row">
                              <div className="item-img-container">
                                <img src={item.cartItemProductImage !== "" ? item.cartItemProductImage : placeholderImage} alt={item.cartItemProductName} />
                              </div>
                              <div className="item-info-container">
                                <div className="item-info-title">
                                  <h6>{item.cartItemProductName}</h6>
                                  <div className="item-extrainfo-options">
                                    {item.cartItemProductComboSet.length > 0 &&
                                      item.cartItemProductComboSet.map((comboitem, comboindex) => {
                                        return (
                                          <React.Fragment key={comboindex}>
                                            <p>
                                              <b>{comboitem.comboName}:</b>{" "}
                                            </p>
                                            {comboitem.products.length > 0 &&
                                              comboitem.products.map((comboProItem, comboProIndex) => {
                                                return (
                                                  <p key={comboProIndex}>
                                                    {comboProItem.productQuantity} X {comboProItem.productName}{" "}
                                                    {parseFloat(comboProItem.productPrice) > 0 ? (
                                                      <>
                                                        (+$
                                                        {parseFloat(comboProItem.productPrice)})
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </p>
                                                );
                                              })}
                                          </React.Fragment>
                                        );
                                      })}
                                    {item.cartItemNote !== "" && (
                                      <p>
                                        <strong>Note:</strong>
                                        {item.cartItemNote}
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div className="item-quantity-box">
                                  <span className="item-qty-inc" onClick={this.incDecQty.bind(this, item.cartItemQuantity, "dec", index, item._id, item)}></span>
                                  <input type="text" value={item.cartItemQuantity} onChange={() => {}} className="item-count-box" />
                                  <span className="item-qty-dec" onClick={this.incDecQty.bind(this, item.cartItemQuantity, "inc", index, item._id, item)}></span>
                                </div>
                              </div>
                              <div className="item-price-action">
                                <div className="item-delete-action">
                                  <a href="/" onClick={this.removeItem.bind(this, item._id)}>
                                    <i className="fa fa-trash-o" aria-hidden="true"></i>{" "}
                                  </a>
                                </div>
                                <div className="item-price-end"> {showPriceDirect(item.cartItemTotalPrice)} </div>
                              </div>
                            </div>
                            {item.timeValidationError === "Yes" && (
                              <div className="cart-item-error">
                                This product is not available for {cookie.load("availabilityName") ?? ""} on the selected date and time. Please refer to the product description.
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </React.Fragment>
                )}
                <div className="items-footer">
                  <div className="item-price-row">
                    <p className="text-uppercase">SUBTOTAL</p>
                    <span>{showPriceDirect(this.state.subtotal)}</span>
                  </div>
                  {this.state.seletedAvilablityId === deliveryId && parseFloat(this.state.deliveryCharge) > 0 && (
                    <div className="item-price-row">
                      <p className="text-uppercase">Delivery</p>
                      <span>{showPriceDirect(this.state.deliveryCharge)} </span>
                    </div>
                  )}
                  {this.state.additionalChargeList.length > 0 &&
                    this.state.additionalChargeList.map((item, index) => {
                      return (
                        <div className="item-price-row" key={index}>
                          <p className="text-uppercase">{item.title}</p>
                          <span>{showPriceDirect(item.amount)}</span>
                        </div>
                      );
                    })}
                  {parseFloat(this.state.discount) > 0 && (
                    <div className="item-price-row">
                      <p className="text-uppercase">Discount({this.state.promoCode})</p>
                      <span>-{showPriceDirect(this.state.discount)} </span>
                    </div>
                  )}
                  {parseFloat(this.state.redeemPointAmount) > 0 && (
                    <div className="item-price-row">
                      <p className="text-uppercase">Redeem Points ({this.state.redeemPoint})</p>
                      <span>-{showPriceDirect(this.state.redeemPointAmount)} </span>
                    </div>
                  )}
                  {this.state.appliedAscentisPoint && parseFloat(this.state.redeemAscentisPoint) > 0 && (
                    <div className="item-price-row">
                      <p className="text-uppercase">Redeem Points ({this.state.redeemAscentisPoint})</p>
                      <span>-{showPriceDirect(this.state.redeemAscentisPoint)} </span>
                    </div>
                  )}
                  {parseFloat(this.state.taxAmount) > 0 && (
                    <div className="item-price-row">
                      <p className="text-uppercase">
                        {this.state.taxType === "Inclusive" ? "Inclusive" : ""} GST ({this.state.taxPercentage}%)
                      </p>{" "}
                      <span>{showPriceDirect(this.state.taxAmount)}</span>
                    </div>
                  )}
                  <div className="item-price-row item-grantprice-row ">
                    <p className="text-uppercase">Total</p> <span>{showPriceDirect(this.state.grandTotal)}</span>
                  </div>
                </div>
                {this.state.seletedAvilablityId === deliveryId && parseFloat(this.state.balancefreedeliveryCharge) > 0 && (
                  <div className="progress-bar-main">
                    <div className="indication">
                      <div className="indication_progress">
                        <span className="hor-progress-bar" style={{ width: `${this.state.freeDeliveryPrecentage}%` }}></span>
                      </div>
                      <p className="help-block">{showPriceDirect(this.state.balancefreedeliveryCharge)} more to FREE delivery!</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/*Payment omise confirm popup Start*/}
        <Popup open={this.state.openomisePopup} onClose={() => this.setState({ openomisePopup: false })} modal closeOnDocumentClick={false} className="popup-master-small">
          <div id="pay-omiseconf-popup" className="pay-omiseconf-popup">
            <div className="omise-error-info-div" id="omise-error-info-div" data-timeoutid="" style={{ display: "none" }}>
              <div className="container">
                <span className="omise-error-icon">
                  <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </span>
                <a
                  href="/"
                  className="omise_alert_close"
                  data-dismiss="alert"
                  aria-label="Close"
                  onClick={(evt) => {
                    evt.preventDefault();
                  }}
                >
                  {" "}
                  <span aria-hidden="true">×</span>{" "}
                </a>
                <p className="omise-error-msg">Something went wrong</p>
              </div>
            </div>

            {this.state.globalSettings.omise_envir === "dev" && <div className="omisepay-mode-option">Test Mode</div>}

            <div className="custom_alert">
              <div className="custom_alertin">
                <div className="alert_height">
                  <div className="omise_pay_header">
                    <span className="omise-pay-img">
                      <img className="omise-logo-img" src={paymentImage} alt={companyName} />
                    </span>
                    <span className="omise-pay-title">{companyName}</span>
                  </div>
                  <div className="omise_pay_body">
                    <div className="omisepop_in">
                      <div className="form_sec">
                        <div className={"uname-box " + this.state.omisenameerror}>
                          <i className="fa fa-user" data-unicode="f007"></i>
                          <input
                            type="text"
                            id="holdername"
                            className="form-control"
                            placeholder="Card Holder Name"
                            value={this.state.holdername}
                            onChange={this.handleChangeTxt.bind(this, "holdername")}
                          />
                        </div>

                        <div className={"card-numbr-div " + this.state.omisecardrror}>
                          <i className="fa fa-credit-card" data-unicode="f09d"></i>
                          <input
                            type="text"
                            className={"form-control " + this.state.cardImage}
                            placeholder="Card Number"
                            value={this.state.cardNumber}
                            id="omise_card_number"
                            onChange={this.handleChangeTxt.bind(this, "cardNumber")}
                          />
                          <span className="card"></span>
                        </div>

                        <div className="form_expire_row">
                          <div className="expire_row_inner">
                            <div className={"expire_left " + this.state.omisemontherror}>
                              <i className="fa fa-calendar-o" data-unicode="f133"></i>
                              <input
                                type="text"
                                className="form-control"
                                maxLength="2"
                                id="expiration_month"
                                placeholder="MM"
                                value={this.state.expiration_month}
                                onChange={this.handleChangeTxt.bind(this, "expiration_month")}
                              />
                            </div>

                            <div className={"expire_mdl " + this.state.omiseyearerror}>
                              <input
                                type="text"
                                placeholder="YY"
                                className="form-control"
                                maxLength="4"
                                id="expiration_year"
                                value={this.state.expiration_year}
                                onChange={this.handleChangeTxt.bind(this, "expiration_year")}
                              />
                            </div>

                            <div className={"expire_right " + this.state.omisecodeerror}>
                              <i className="fa fa-lock" data-unicode="f023"></i>
                              <input
                                type="password"
                                maxLength="3"
                                className="form-control"
                                id="security_code"
                                placeholder="CVV"
                                value={this.state.security_code}
                                onChange={this.handleChangeTxt.bind(this, "security_code")}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="alt_btns">
                          {this.state.omiseKey !== "" && this.state.enableOmise === true && (
                            <button className="button omise-pay-btn" id="prcessOmise" onClick={this.generateOmiseToken.bind(this)}>
                              Pay {currency} {parseFloat(this.state.grandTotal).toFixed(2)}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Popup>
        {/*payment omise confirm popup - End*/}

        {/*Payment omise confirm popup Start*/}
        <Popup open={this.state.openomisePayNowPopup} onClose={() => this.setState({ openomisePayNowPopup: false })} modal closeOnDocumentClick={false} className="popup-master-small">
          <div id="pay-omiseconf-popup" className="pay-omiseconf-popup">
            <div className="omise-error-info-div" id="omise-error-info-div" data-timeoutid="" style={{ display: "none" }}>
              <div className="container">
                <span className="omise-error-icon">
                  <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                </span>
                <a
                  href="/"
                  className="omise_alert_close"
                  data-dismiss="alert"
                  aria-label="Close"
                  onClick={(evt) => {
                    evt.preventDefault();
                  }}
                >
                  {" "}
                  <span aria-hidden="true">×</span>{" "}
                </a>
                <p className="omise-error-msg">Something went wrong</p>
              </div>
            </div>

            {this.state.globalSettings.omise_envir === "dev" && <div className="omisepay-mode-option">Test Mode</div>}

            <div className="custom_alert">
              <div className="custom_alertin">
                <div className="alert_height">
                  <div className="omise_pay_header">
                    <span className="omise-pay-img">
                      <img className="omise-logo-img" src={paymentImage} alt={companyName} />
                    </span>
                    <span className="omise-pay-title">{companyName}</span>
                  </div>
                  <div className="omise_pay_body">
                    <div class="omisepop_in">
                      <p class="omise-pay-now-notes">Scan the QR code to pay.</p>
                      <img src={this.state.omisePayNowQRCode} id="paynow-qr-image" alt="QR Code" />
                      <p class="omise-paynow-amount-to-paid">
                        <span>{currency} {parseFloat(this.state.grandTotal).toFixed(2)}</span>
                      </p>
                      <p class="paynow-seconds">
                        <i class="fa fa-clock-o" aria-hidden="true"></i>
                        <span>&nbsp;{this.state.omisePayNowBalanceTime} sec</span>
                      </p>
                      <div class="paynow-notes">
                        <h2>Instructions:</h2>
                        <ul>
                          <li>
                            <i class="fa fa-dot-circle-o" aria-hidden="true"></i>
                            Use your bank app to scan QR Code and pay.
                          </li>
                          <li>
                            <i class="fa fa-dot-circle-o" aria-hidden="true"></i>
                            You will be paying to Omise Payment SG (Authorised payment processor) for
                          </li>
                          <li>
                            <i class="fa fa-dot-circle-o" aria-hidden="true"></i>
                            Page will automatically refresh after your successful payment.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Popup>
        {/*payment omise confirm popup - End*/}

        <Popup open={this.state.OTPPopup} onClose={() => this.setState({ OTPPopup: false })} modal closeOnDocumentClick={false} className="popup-master-small">
          <div className="popup-cover">
            <div className="verification-region">
              <div className="pm-close">
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({ OTPPopup: false });
                  }}
                >
                  <img className="close-top" src={closei} alt="close" />
                </a>
              </div>
              <div className="pm-header">
                <h4>Enter verification code</h4>
                <span>Please enter the 6-digit verification code that was sent to {this.maskEmail(localStorage.getItem("email") ?? "")}</span>
              </div>

              <div className="verfication-box-form">
                <div className="form-group">
                  <input
                    className="form-control"
                    maxLength="1"
                    id="otp1"
                    type="text"
                    ref={this.otp1Ref}
                    value={this.state.otp1}
                    onChange={this.handleChange.bind(this, "otp1")}
                    onPasteCapture={this.onPasteCaptureHandler.bind(this)}
                    autoComplete="off"
                  />
                  <input className="form-control" maxLength="1" id="otp2" type="text" ref={this.otp2Ref} value={this.state.otp2} onChange={this.handleChange.bind(this, "otp2")} autoComplete="off" />
                  <input className="form-control" maxLength="1" id="otp3" type="text" ref={this.otp3Ref} value={this.state.otp3} onChange={this.handleChange.bind(this, "otp3")} autoComplete="off" />
                  <input className="form-control" maxLength="1" id="otp4" type="text" ref={this.otp4Ref} value={this.state.otp4} onChange={this.handleChange.bind(this, "otp4")} autoComplete="off" />
                  <input className="form-control" maxLength="1" id="otp5" type="text" ref={this.otp5Ref} value={this.state.otp5} onChange={this.handleChange.bind(this, "otp5")} autoComplete="off" />
                  <input className="form-control" maxLength="1" id="otp6" type="text" ref={this.otp6Ref} value={this.state.otp6} onChange={this.handleChange.bind(this, "otp6")} autoComplete="off" />
                  {this.state.otpError !== "" && <span className="error">{this.state.otpError}</span>}
                </div>
                <div className="form-group-link">
                  <a href="/" onClick={this.resetOTP.bind(this)}>
                    I haven’t received the code{" "}
                  </a>
                </div>
              </div>

              <div className="pm-single-button">
                <button className="button" id="verifyOTP" onClick={this.confirmOTP.bind(this)}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
const mapStateTopProps = (state) => {
  let cartDetails = "";
  let totalItem = 0;
  let cartstatus = "";
  let additionalChargeList = [];
  let additionalChargeAmount = 0;
  if (Object.keys(state.cartdetails).length > 0) {
    if (state.cartdetails[0].status === "ok") {
      cartDetails = state.cartdetails[0].result;
      totalItem = state.cartdetails[0].totalItem;
      additionalChargeList = state.cartdetails[0].additionalChargeList;
      additionalChargeAmount = state.cartdetails[0].additionalChargeAmount;
    } else {
      cartstatus = "faild";
    }
  }
  var globalSettings = [];
  if (Object.keys(state.settings).length > 0) {
    if (state.settings[0].status === "ok") {
      globalSettings = state.settings[0].result;
    }
  }

  return {
    cartDetails: cartDetails,
    totalItem: totalItem,
    additionalChargeList: additionalChargeList,
    additionalChargeAmount: additionalChargeAmount,
    cartstatus: cartstatus,
    settingsArr: globalSettings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCartDetail: () => {
      dispatch({ type: GET_CART_DETAIL });
    },
    getGlobalSettings: () => {
      dispatch({ type: GET_GLOBAL_SETTINGS });
    },
  };
};
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(Checkout));
